import collectBonusAttackDice from '../../gameStateMachine/helpers/battle/collectBonusAttackDice.js';
import collectBonusDefenseDice from '../../gameStateMachine/helpers/battle/collectBonusDefenseDice.js';
import collectBonusSymbols from '../../gameStateMachine/helpers/battle/collectBonusSymbols.js';
import { BattleBonusPurpose } from '@wareena/grid-battles-entity/game/codebook/battleBonus';
import calculateChanceTable from '../../services/calculateChanceTable.js';
function getHitsProbability(attacker, defender, neededHits, rules) {
    const hasAdvantage = rules.doesHaveAdvantageAgainst(attacker, defender);
    const attackerBonuses = rules.getBonusesForUnit(attacker);
    const defenderBonuses = rules.getBonusesForUnit(defender);
    const { chanceForHits } = calculateChanceTable([...attacker.attackDice, ...collectBonusAttackDice(attackerBonuses)], [...defender.defenseDice, ...collectBonusDefenseDice(defenderBonuses)], collectBonusSymbols(attackerBonuses, BattleBonusPurpose.Attack), collectBonusSymbols(defenderBonuses, BattleBonusPurpose.Defense), hasAdvantage);
    return chanceForHits.find((chance) => chance.hits === neededHits)?.atLeastChance ?? 0;
}
export function getChanceToDealHits(agentUnit, enemyUnit, neededHits, rules) {
    return getHitsProbability(agentUnit, enemyUnit, neededHits, rules);
}
export default getHitsProbability;
